import { SelectItemProps } from '@ui/src';
import {
  PspAccountCurrencyType,
  PspAccountType,
  PspPartnerLocation,
  PspPartnerPaymentType,
  PspPartnerType,
  PspAccountLogsType,
  PspPartnerOperationType,
} from '../types';

export const getPspAccountType = (type: string) => {
  let typeName;

  switch (type) {
    case PspAccountType.SEGGREGATED:
      typeName = 'Segregated';
      break;
    case PspAccountType.OWN_FUNDS:
      typeName = 'Own funds';
      break;
    case PspAccountType.SAFEGUARDING:
      typeName = 'Safeguarding';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export const getPspAccountCurrencyType = (type: string) => {
  let typeName;

  switch (type) {
    case PspAccountCurrencyType.ALL:
      typeName = 'All';
      break;
    case PspAccountCurrencyType.SPECIFIC:
      typeName = 'Specific';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export const getPspPartnerLocation = (type: string) => {
  let typeName;

  switch (type) {
    case PspPartnerLocation.DOMESTIC:
      typeName = 'Domestic';
      break;
    case PspPartnerLocation.FOREIGN:
      typeName = 'Foreign';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export const getPspPartnerType = (type: string) => {
  let typeName;

  switch (type) {
    case PspPartnerType.CREDIT:
      typeName = 'Credit institution';
      break;
    case PspPartnerType.EMONEY:
      typeName = 'E-money institution';
      break;
    case PspPartnerType.PAYMENT:
      typeName = 'Payment institution';
      break;
    case PspPartnerType.BLOCKCHAIN_CUSTODIAN_EXCHANGE:
      typeName = 'Blockchain/Custodian/Exchange';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export const getPspPartnerPaymentType = (type: string) => {
  let typeName;

  switch (type) {
    case PspPartnerPaymentType.BACS:
      typeName = 'BACS';
      break;
    case PspPartnerPaymentType.FASTER_PAYMENT:
      typeName = 'Faster payment';
      break;
    case PspPartnerPaymentType.SEPA_SCT:
      typeName = 'SEPA SCT';
      break;
    case PspPartnerPaymentType.SEPA_SCT_INST:
      typeName = 'SEPA SCT INST';
      break;
    case PspPartnerPaymentType.SWIFT:
      typeName = 'SWIFT';
      break;
    case PspPartnerPaymentType.TARGET_2:
      typeName = 'Target 2';
      break;
    case PspPartnerPaymentType.FEDWIRE:
      typeName = 'Fedwire';
      break;
    case PspPartnerPaymentType.CRYPTO_ASSET_PAYMENT:
      typeName = 'Crypto Asset Payment';
      break;
    case PspPartnerPaymentType.CASH_OVER_COUNTER:
      typeName = 'Cash Over Counter';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};

export const getPspAccountLogsType = (
  type: string,
  value: string,
  currencies: SelectItemProps[],
) => {
  let typeName;
  let operationValue;

  switch (type) {
    case PspAccountLogsType.PSPA_ACCOUNT_ID:
      typeName = 'Edit Account ID';
      operationValue = value;
      break;
    case PspAccountLogsType.PSPA_CURRENCY_ID:
      typeName = 'Edit Currency';
      operationValue = currencies.find(
        (currency) => currency.value === value,
      )?.suffix;
      break;
    case PspAccountLogsType.PSPA_CURRENCY_TYPE:
      typeName = 'Edit Currency Type';
      operationValue = getPspAccountCurrencyType(value);
      break;
    case PspAccountLogsType.PSPA_DESCRIPTION:
      typeName = 'Edit Description';
      operationValue = value;
      break;
    case PspAccountLogsType.PSPA_TYPE:
      typeName = 'Edit Account Type';
      operationValue = getPspAccountType(value);
      break;
    case PspAccountLogsType.PSPA_VISIBLE_TO_CLIENT:
      typeName = 'Edit Visibility To Client';
      operationValue = value ? 'Visible' : 'Hidden';
      break;
    default:
      typeName = type;
      operationValue = value;
      break;
  }

  return { typeName, operationValue };
};

export const getPspPartnerLogTypes = (type: string) => {
  let typeName;

  switch (type) {
    case PspPartnerOperationType.PSP_ACTIVE:
      typeName = 'Edit Active Status';
      break;
    case PspPartnerOperationType.PSP_ADDRESS:
      typeName = 'Edit Address';
      break;
    case PspPartnerOperationType.PSP_COMPANY_NAME:
      typeName = 'Edit Company Name';
      break;
    case PspPartnerOperationType.PSP_COUNTRY_ID:
      typeName = 'Edit Country';
      break;
    case PspPartnerOperationType.PSP_DESCRIPTION:
      typeName = 'Edit Description';
      break;
    case PspPartnerOperationType.PSP_LEGAL_NAME:
      typeName = 'Edit Legal Name';
      break;
    case PspPartnerOperationType.PSP_LOCATION:
      typeName = 'Edit Location';
      break;
    case PspPartnerOperationType.PSP_MANAGER_CONTACTS:
      typeName = 'Edit Manager Contacts';
      break;
    case PspPartnerOperationType.PSP_ONLINE_BANK_LINK:
      typeName = 'Edit Online Bank Link';
      break;
    case PspPartnerOperationType.PSP_PARTNER_TYPE:
      typeName = 'Edit Partner Type';
      break;
    case PspPartnerOperationType.PSP_PAYMENT_TYPE:
      typeName = 'Edit Payment Type';
      break;
    case PspPartnerOperationType.PSP_SWIFT:
      typeName = 'Edit SWIFT';
      break;
    default:
      typeName = type;
      break;
  }

  return typeName;
};
